
export class Page {
    public PageNumber: number;
    public Data: any[];

    constructor() {
        this.Data = [];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/page.ts